<template>
  <div>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          shortcut="2024"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
          noClearButton
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
      <app-select
        @input="fetchGraphs"
        v-model="camp_filter"
        :reduce="item => item.id"
        :options="camps_options"
        :filterable="false"
        :searchable="false"
        placeholder="Gate"
        class="select--250"
        style="margin: 0"
      />
      <app-filters
        v-model="period_filter"
        :filters="period_filters"
        name="filterPeriod"
        @change="fetchGraphs"
      />
      <app-filters
        v-model="type_filter"
        :filters="type_filters"
        name="filterType"
        @change="fetchGraphs"
      />
    </app-cells>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <div class="info-row">
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ card_data.alteza.toLocaleString() }}</span>
            <span class="info-row__text">Altezza</span>
          </div>
        </div>
        <div class="info-row__item">
          <div class="info-row__content">
            <span class="info-row__value">{{ card_data.kinapa.toLocaleString() }}</span>
            <span class="info-row__text">KINAPA</span>
          </div>
        </div>
      </div>
      <div class="charts-grid">
        <highcharts :options="graph_options" />
      </div>
      <div class="charts-grid">
        <highcharts :options="graph_options_week" />
      </div>
    </template>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { Chart } from 'highcharts-vue'
import moment from 'moment'
import {
  getClimbingCamps,
  getClimbingGroupsClientsGateDaysAnalytics,
  getClimbingGroupsClientsGateWeekDaysAnalytics,
} from '@/http'

export default {
  name: 'ClimbingAnalyticsKinapa',
  components: { VueCtkDateTimePicker, highcharts: Chart },
  data() {
    return {
      is_loaded: false,
      filter_dates: null,
      date_picker_error: false,
      custom_shortcuts: [
        {
          key: '2023',
          label: '2023',
          value: () => {
            return {
              start: moment('20230101'),
              end: moment('20231231')
            }
          }
        },
        {
          key: '2024',
          label: '2024',
          value: () => {
            return {
              start: moment('20240101'),
              end: moment('20241231')
            }
          }
        },
      ],
      graph_options: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      graph_options_week: {
        accessibility: {
          enabled: false,
        },
        CSSObject: {
          fontFamily: 'regular',
          fontSize: '6.2em',
        },
        chart: {
          type: 'spline'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
            }
          }
        },
        series: []
      },
      camps_options: [],
      camp_filter: null,
      period_filter: 'month',
      period_filters: [
        { value: 'month', label: 'Month' },
        { value: 'day', label: 'Day' },
      ],
      type_filter: '',
      type_filters: [
        { value: '', label: 'All' },
        { value: 'join', label: 'Join' },
        { value: 'private', label: 'Private' },
      ],
      card_data: {
        alteza: null,
        kinapa: null,
      },
    }
  },
  mounted() {
    Promise.all([this.fetchGraphDays(), this.fetchGraphWeekDays()])
      .then(() => { this.is_loaded = true })
    getClimbingCamps({ gate: true }).then(response => { this.camps_options = response.data })
  },
  methods: {
    fetchGraphs() {
      this.fetchGraphDays()
      this.fetchGraphWeekDays()
    },
    async fetchGraphDays() {
      const response = await getClimbingGroupsClientsGateDaysAnalytics({
        from_date: this.filter_dates?.start,
        to_date: this.filter_dates?.end,
        group_by: this.period_filter,
        gate: this.camp_filter,
        type: this.type_filter
      })
      this.graph_options.xAxis.categories = response.data.graph.categories
      this.graph_options.series = response.data.graph.series
      this.card_data.alteza = response.data.altezza_count
      this.card_data.kinapa = response.data.kinapa_count
    },
    async fetchGraphWeekDays() {
      const response = await getClimbingGroupsClientsGateWeekDaysAnalytics({
        from_date: this.filter_dates?.start,
        to_date: this.filter_dates?.end,
        gate: this.camp_filter,
        type: this.type_filter
      })
      this.graph_options_week.xAxis.categories = response.data.categories
      this.graph_options_week.series = response.data.series
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchGraphs()
      } else this.date_picker_error = true
    },
  }
}
</script>

<style lang="sass" scoped>
.date-picker-wrapper
  position: relative

.date-picker-wrapper__error
  position: absolute
  bottom: -18px
  color: $color-error
  font-size: 12px
</style>
